<template>
    <guest-layout>
        <div class="form-col mh-100">
            <div class="arrow-back d-none d-lg-block">
                <a :href="route('login')"><span><i class="feather-chevron-left"></i></span>Back to login</a>
            </div>
            <div class="register-content">
                <span>Don't have an account? <a :href="route('register')" class="register-text">Register</a></span>
            </div>
            <div class="web-form">
                <div class="title-col">
                    <h2>Reset password</h2>
                    <p>Type in your Email to receive password reset instructions</p>
                </div>
                <div class="success" v-if="status">
                    {{ status }}
                </div>
                <form class="form-style" @submit.prevent="submit" v-if="!status">
                    <div class="form-group">
                        <label class="label-style" for="emailFld">Email address*</label>
                        <div class="input-col">
                            <input type="email" class="form-control input-style" id="email" v-model="form.email" required autofocus/>

                            <div v-if="form.errors.email" v-bind:style="styleObject">{{ form.errors.email }}</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <button type="submit" class="btn btn-style btn-primary w-100" :disabled="form.processing"><span>Send me instructions</span></button>
                    </div>
                </form>
            </div>
        </div>
    </guest-layout>
</template>

<script>
    import GuestLayout from "@/Layouts/GuestLayout";
    export default {
        components: {
            GuestLayout,
        },

        props: {
            status: String
        },

        data() {
            return {
                form: this.$inertia.form({
                    email: ''
                }),
                styleObject: {
                    color: 'red',
                    fontSize: '15px'
                }
            }
        },

        methods: {
            submit() {
                this.form.post(this.route('password.email'))
            }
        }
    }
</script>
